export enum InventoryLocationFilterOptions {
  ALL_LOCATIONS = "ALL_LOCATIONS",
  ECOM_FULFILLMENT = "ECOM_FULFILLMENT",
  RESERVE_STORAGE = "RESERVE_STORAGE",
  AMAZON_FBA = "AMAZON_FBA",
  WALMART_WFS = "WALMART_WFS",
}
